import React, { useEffect, useState, Fragment } from 'react';
import { CTAButton } from './CTAButton';
import { Star, Shield } from 'lucide-react';
const PRODUCT_IMG = 'https://cdn.magicpatterns.com/uploads/kr1tAmQu43YLunWY8i225F/ChatGPT-Image-8-jul-2026_-09_50_12-p.m..webp';
const CHECKOUT_URL = 'https://dance-pro-francia.impultienda.ar/checkout';
export function PricingCard() {
  const [timeLeft, setTimeLeft] = useState({
    hours: 1,
    minutes: 45,
    seconds: 30
  });
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        let {
          hours,
          minutes,
          seconds
        } = prev;
        if (seconds > 0) seconds--;else if (minutes > 0) {
          minutes--;
          seconds = 59;
        } else if (hours > 0) {
          hours--;
          minutes = 59;
          seconds = 59;
        } else {
          hours = 1;
          minutes = 45;
          seconds = 30;
        }
        return {
          hours,
          minutes,
          seconds
        };
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  return <section id="pricing" className="py-8 px-4 sm:px-6 bg-brand-ivory border-y-4 border-brand-gold/40 scroll-mt-2" data-id="element-122">
      <div className="text-center mb-6" data-id="element-123">
        <p className="text-sm font-heading font-bold text-brand-gold uppercase tracking-widest mb-2" data-id="element-124">
          Offerta Speciale — Sistema Completo 6-in-1
        </p>
        <p className="text-base font-bold text-brand-navy mb-4 leading-tight max-w-md mx-auto" data-id="element-125">
          Accedi subito al sistema completo e trasforma il modo in cui prepari e
          organizzi i tuoi allenamenti.
        </p>
        <div className="inline-block bg-brand-navy text-white px-4 py-2 rounded-md shadow-sm mb-4" data-id="element-126">
          <p className="font-heading font-bold text-sm tracking-wide leading-snug" data-id="element-127">
            🤸 GINNASTICA PRO™ — Sistema Completo 6-in-1 per Allenatori di
            Ginnastica Artistica
          </p>
        </div>
        <a href={CHECKOUT_URL} target="_blank" rel="noopener noreferrer" className="block cursor-pointer" data-id="element-128">
          <img src={PRODUCT_IMG} alt="GINNASTICA PRO - Box Set" className="w-full max-w-[300px] mx-auto object-contain drop-shadow-xl mb-4 hover:scale-[1.02] transition-transform" data-id="element-129" />
        </a>
      </div>

      <div className="bg-white border-4 border-brand-gold rounded-xl p-5 text-center relative mb-4 shadow-2xl" data-id="element-130">
        <div className="mb-4" data-id="element-131">
          <p className="text-base font-bold text-brand-muted mb-1" data-id="element-132">
            Prezzo di Listino: <span className="line-through" data-id="element-133">97€</span>
          </p>
          <p className="text-base font-heading font-bold text-red-600 mb-2 uppercase tracking-wide leading-tight" data-id="element-134">
            🔥 72% di Sconto — Offerta di Lancio a Tempo Limitato
          </p>
          <p className="text-sm font-bold text-brand-navy uppercase tracking-wide" data-id="element-135">
            Oggi Solo:
          </p>
          <p className="text-6xl font-heading font-extrabold text-brand-navy mb-1 leading-none" data-id="element-136">
            27€
          </p>
          <p className="text-xs font-bold text-brand-muted uppercase tracking-wider mt-2" data-id="element-137">
            Pagamento sicuro nella tua valuta.
          </p>
        </div>

        <div className="bg-red-50 border border-red-200 rounded-lg p-3 mb-5" data-id="element-138">
          <p className="text-sm font-bold text-red-600 mb-2 uppercase tracking-tight" data-id="element-139">
            🔥 Questa offerta scadrà allo scadere del conto alla rovescia.
          </p>
          <div className="flex justify-center gap-3" data-id="element-140">
            {[{
            v: timeLeft.hours,
            l: 'ORE'
          }, {
            v: timeLeft.minutes,
            l: 'MINUTI'
          }, {
            v: timeLeft.seconds,
            l: 'SECONDI'
          }].map((unit, i) => <Fragment key={unit.l} data-id="element-141">
                {i > 0 && <div className="text-2xl font-bold text-brand-navy mt-1" data-id="element-142">
                    :
                  </div>}
                <div className="text-center" data-id="element-143">
                  <div className="bg-brand-navy text-white text-2xl font-heading font-bold px-3 py-1.5 rounded-md shadow-inner leading-none" data-id="element-144">
                    {String(unit.v).padStart(2, '0')}
                  </div>
                  <p className="text-[10px] font-bold text-brand-text mt-1 tracking-wider" data-id="element-145">
                    {unit.l}
                  </p>
                </div>
              </Fragment>)}
          </div>
        </div>

        <CTAButton href={CHECKOUT_URL} data-id="element-146">
          🚀 SÌ! VOGLIO GINNASTICA PRO™
        </CTAButton>
      </div>

      <div className="flex flex-col sm:flex-row justify-center items-center gap-2 sm:gap-6 text-xs sm:text-sm text-brand-text font-bold" data-id="element-147">
        <div className="flex items-center gap-1.5" data-id="element-148">
          <Star className="w-4 h-4 fill-brand-gold text-brand-gold" data-id="element-149" />
          <span data-id="element-150">4.9/5 — Recensioni Verificate dagli Allenatori</span>
        </div>
        <div className="flex items-center gap-1.5" data-id="element-151">
          <Shield className="w-4 h-4 text-brand-violet" data-id="element-152" />
          <span data-id="element-153">Garanzia 14 Giorni — Zero Rischi</span>
        </div>
      </div>
    </section>;
}